import { LoaderFunction, useFetcher } from "react-router-dom";
import { getMarketplaceOptions } from "../../../common/api/decimal/methods/product.ts";

export const marketplaceLoader: LoaderFunction = async ({ params }) => {
  return getMarketplaceOptions(params.sku!);
};

export const useMarketplaceFetcher = () => {
  return useFetcher<Awaited<ReturnType<typeof getMarketplaceOptions>>>();
};
